<template>
    <div class="edit-race-number-container">
        <h4 class="event-title">{{ entry.event.name }}
            <template v-if="entry.timing_pen.id">
                – {{ entry.timing_pen.colour }}
                <colour-block :colour="entry.timing_pen.colour_code"></colour-block>
            </template>
        </h4>
        <div v-if="multipleEntries">
          <p class="multiple-note">This person has more than one future entry, please scroll down and select which entry requires a new number</p>
        </div>
        <div v-if="!multipleEntries">
          <race-number-edit :entry="entry" class="edit-race-number" :large="true">
                <template v-slot:race-number="slotProps" class="big-race-number">
                    <span>{{ slotProps.number }}</span>
                </template>
              <template v-slot:edit-button="{ toggleEdit, loadingRaceNumbers, assignNextNumber }">
                <button class="btn btn-lg"
                        @click="assignNextNumber">
                  <template v-if="! loadingRaceNumbers">Assign new event number</template>
                  <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Loading...</template>
                </button>
              </template>
          </race-number-edit>
        </div>
    </div>
</template>

<script>
  import EntryStatusLabel from './EntryStatusLabel.vue';
  import RaceNumberEdit from "./RaceNumberEdit";
  import ColourBlock from '../Support/ColourBlock.vue';
  import InfoLabels from "./InfoLabels";
  import { mapGetters } from 'vuex';

  export default {
    props: ['person'],

    components: {
      InfoLabels,
      RaceNumberEdit,
      EntryStatusLabel,
      ColourBlock,
    },

    computed: {
      ...mapGetters(['firstApprovedEntry', 'hasManyEntries']),

      multipleEntries() {
        return this.hasManyEntries;
      },

      entry() {
        return this.firstApprovedEntry;
      },
    },
  };
</script>

<style scoped lang="scss">
    .big-race-number {
        font-size: 36px;
        line-height: 36px;
        margin-left: 10px;
        margin-right: 10px;
    }

    .edit-race-number {
        margin-left: auto;
        margin-right: auto;

        button {
            margin-top: -18px;
        }
    }

    .edit-race-number-container {
        text-align: center;
        margin-bottom: 20px;
        margin-left: auto;
        margin-right: auto;
    }

    .event-title {
        margin-bottom: 20px;
    }

    .multiple-note {
      font-weight:bold;
      padding: 3px 6px;
      border: 1px solid rgb(56, 94, 154);
      background: #C8D9F5;
      width: fit-content;
      margin: 0 auto;
      border-radius: 5px;
      color: rgb(56, 94, 154);
    }
</style>
